<template>
  <v-layout row wrap>
    <v-flex lg12>
      <v-card class="elevation-15">
        <v-toolbar color="default" class="title font-weight-bold elevation-0 pa-2">
          NUESTROS ACCESOS
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-layout row wrap align-center no-gutters>
            <v-flex md3 sm6 xs6>
              <a href="https://sra.justicia.gob.bo/" target="_blank" rel="noopener noreferrer">
                <v-avatar size="100" class="elevation-3">

                <v-img
                  :src="require('@/assets/logo-oficina-virtual.png')"
                  max-height="100"
                  contain
                  class="mx-auto"
                ></v-img>

                </v-avatar>
              </a>
              <p class="mt-2 mb-0"><b>Oficina virtual</b></p>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <a href="https://play.google.com/store/apps/details?id=bo.gob.justicia.rpa&hl=es_BO" target="_blank" rel="noopener noreferrer">
                <v-avatar size="100" class="elevation-3">

                <v-img
                  :src="require('@/assets/logo-app-movil.png')"
                  max-height="100"
                  contain
                  class="mx-auto"
                ></v-img>

                </v-avatar>
              </a>
              <p class="mt-2 mb-0"><b>APP móvil</b></p>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <a href="https://moodlex.justicia.gob.bo/" target="_blank" rel="noopener noreferrer">
                <v-avatar size="100" class="elevation-3">

                <v-img
                  :src="require('@/assets/logo-aula-virtual.png')"
                  max-height="100"
                  contain
                  class="mx-auto"
                ></v-img>

                </v-avatar>
              </a>
              <p class="mt-2 mb-0"><b>Aula virtual</b></p>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <a href="https://tribunaletica.justicia.gob.bo/" target="_blank" rel="noopener noreferrer">
                <v-avatar size="100" class="elevation-3">

                <v-img
                  :src="require('@/assets/logo-notificaciones.png')"
                  max-height="100"
                  contain
                  class="mx-auto"
                ></v-img>

                </v-avatar>
              </a>
              <p class="mt-2 mb-0"><b>Tablero de notificaciones</b></p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex lg12>
      <v-card class="elevation-15">
        <v-toolbar color="default" class="title font-weight-bold elevation-0 pa-2">
          UNIDAD DE REGISTRO PÚBLICO DE LA ABOGACÍA
        </v-toolbar>

        <v-card-text class="pa-3">
          <p class="text-xs-justify">{{this.$store.state.msg.rpa.descripcion}}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="registro">
          <template slot="contador" v-if="conteoMatriculado>0">
              <Contador :valor="conteoMatriculado" :descripcion="registro.conteo.descripcion"/>
          </template>
          <template slot="accionesTramite">
             <v-btn color="primary" to="/registro" small round><v-icon class="pr-2">checklist_rtl</v-icon> ver requisitos</v-btn>
          </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="cursos">
        <template slot="accionesTramite">
             <v-btn color="primary" to="/Capacitacion" small round><v-icon class="pr-2">visibility</v-icon> ver cursos</v-btn>
        </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="ruanna">
          <template slot="contador" v-if="conteoRuanna>0">
              <Contador :valor="conteoRuanna" :descripcion="ruanna.conteo.descripcion"/>
          </template>
          <template slot="accionesTramite">
             <v-btn color="primary" href='https://sra.justicia.gob.bo' target='_blank' small round><v-icon class="pr-2">edit</v-icon> regístrate</v-btn>
        </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="control">
        <template slot="accionesTramite">
             <v-btn color="primary" to="/denuncia" small round><v-icon class="pr-2">format_list_numbered</v-icon> ver procedimiento</v-btn>
        </template>
      </Tramite>
    </v-flex>
    <v-flex d-flex xl6 lg6 md12 sm12 >
      <Tramite :tramite="centro_conciliacion">
        <template slot="accionesTramite">
          <v-btn color="primary" :href='`${$apiUrl}/files/centros_conciliacion_arbitraje_autorizados.pdf`' target='_blank' small round><v-icon class="pr-2">visibility</v-icon> Ver lista</v-btn>
          <!-- <wa-icon name="arrow-up-right-from-square"></wa-icon> -->
        </template>
      </Tramite>
    </v-flex>
  </v-layout>
</template>
<script>
import Tramite from "@/components/Inicio/Tramite";
import Contador from "@/components/Inicio/Contador";
export default {
  data() {
    return {
       registro: {
          titulo: "1.- REGISTRO",
          descripcion:
            "Registro de profesionales abogadas, abogados que tienen credencial vigente.",
          imagen:
            // "https://pngimage.net/wp-content/uploads/2018/06/icono-nuevo-registro-png-4.png",
            require('@/assets/registro.png'),
          conteo:{
              descripcion:'Abogadas(os) Matriculadas(os) en RPA'
          },
          acciones:true
        },

        cursos:{
           titulo:'2.- CAPACITACIÓN Y CONTROL',
            // descripcion: 'La Unidad de Registro Público de la Abogacía viene desarrollando continuamente cursos, seminarios y talleres dirigidos a sus afiliados en todo el territorio nacional, difundiendo la práctica y el conocimiento de la ciencia del Derecho.',
            descripcion: 'La Unidad de Registro Público de la Abogacía a través de su área de Capacitación y Control viene desarrollando continuamente cursos, seminarios y talleres dirigidos a sus afiliados en todo el territorio nacional, difundiendo la práctica y el conocimiento de la ciencia del Derecho.<br>A través del control profesional hace los despliegues de Brigadas Móviles de información y control en las distintas entidades estatales y el órgano judicial.',
            // imagen: 'https://geoinnova.org/cursos/wp-content/uploads/2017/07/titulos.png',

            imagen: require('@/assets/capacitacion.png'),
            acciones:true,
        },

        ruanna:{
            titulo:'3.- RUANNA',
            descripcion: 'Registro Único de Abogadas, Abogados para la defensa Técnica, Gratuita y Especializada de Niñas, Niños y Adolecentes Víctimas de Delitos de Violencia.',
            // imagen: 'https://ruanna.justicia.gob.bo/static/img/ruanna.77a5738.png',
            imagen: require('@/assets/ruana.png'),
            acciones:true,
            conteo:{
              descripcion:'Abogadas(os) Registradas(os) en RUANNA'
            }

        },

        control:{
            titulo:'4.- PROCESAMIENTO DE DENUNCIAS POR FALTAS A LA ÉTICA PROFESIONAL.',
            descripcion: 'La Unidad de Registro Público de la Abogacía, por mandato de la Ley N° 387  tiene su atribución de “velar por el correcto ejercicio Profesional de la Abogacía” y las abogadas y los abogados, se someterán al control del ejercicio profesional mediante los Tribunales de Ética de la Abogacía del Ministerio de Justicia y Transparencia Institucional.',
            // imagen: 'https://apirpa2.justicia.gob.bo/imagenes/sanciones.jpg'
            imagen: require('@/assets/ley.png'),
            acciones:true,
        },

        centro_conciliacion:{
            titulo:'5.- CENTRO DE CONCILIACIÓN RPA.',
            descripcion: '',
            // imagen: 'https://apirpa2.justicia.gob.bo/imagenes/sanciones.jpg'
            imagen: require('@/assets/documentoPDF.png'),
            acciones:true,
        }
    };
  },
  computed:{
    conteoRuanna(){
      return this.$store.state.cantidad.ruanna
    },
    conteoMatriculado(){
      return this.$store.state.cantidad.matriculados
    }
  },
  components: {
    Tramite,Contador
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inicio/Descripcion.vue